import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import MissionVission from '../../components/MissionVission/MissionVission';
import About4 from '../../components/about4/about4';
import Footer from '../../components/footer/Footer';
import Navbar2 from '../../components/Navbar2/Navbar2'
import Logo from '../../images/logo2.png'

const AboutPage = () => {
    return (
        <Fragment>
            <Navbar2 hclass={'wpo-header-style-1'} Logo={Logo} />
            <PageTitle pageTitle={'Hakkımızda'} pagesub={'Hakkımızda'} />
            <MissionVission />
            <About4 />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutPage;
